<template>
  <el-card>
    <template v-slot:header>
      <div class="clearfix">
        <span style="font-weight: bold;"><i class="el-icon-pie-chart" style="font-weight: bold;font-size: larger;margin-right: 5px;"></i>Chromosome Distribution</span>
      </div>
    </template>
    <div class="container">
      <div id="chr" style="width:100%;height:500px;"></div> 
    </div>
  </el-card>
</template>
  
<script>
export default {
  props: {
    species: {
      type: String,
      required: true
    },
    tissue: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      chartData: [],
      url: "http://183.175.59.4/devenhancer/",// 后端接口地址
    };
  },
  mounted() {
    // 初始化 echarts 饼图实例
    this.chartPie = this.$echarts.init(document.getElementById('chr'));
    this.handleAnalysis();
  },
  methods: {
    handleAnalysis() {
      // 发送请求获取后端数据
      const params = { Species: this.species, Tissue: this.tissue };
      this.$axios.get(this.url + "compartment" + "/", { params })
        .then((response) => {
          // 对数据进行处理
          const res = response.data;
          const chr_num = res.map(item => item.Chr); // 提取每个对象中的 Chr 属性值，item.chr注意要对应后端的chr
          const data = [];
          let total = 0;
          for (const i in chr_num) {
            const chr = chr_num[i];
            if (chr in data) {
              data[chr] += 1;
            } else {
              data[chr] = 1;
            }
            total += 1;
          }
          // 统计所需字符串出现的次数及占比
          const selectedData = [];
          for (const name of ["chr1","chr2","chr3","chr4","chr5","chr6","chr7","chr8","chr9","chr10",
                              "chr11","chr12","chr13","chr14","chr15","chr16","chr17","chr18","chr19",
                              "chr20","chr21","chr22","chrX","chrY"]) {
            if (name in data) {
              const value = data[name];
              const percent = (value / total * 100).toFixed(2);
              selectedData.push({ value, name: name+' ('+percent+'%)' });
            }
          }
          // 将处理好的数据存入 chartData 中
          this.chartData = selectedData;
          // 更新 echarts 饼图数据
          this.updatePie();
        })
        .catch((error) => {
          console.error(error);
          this.$message.error('Failed to fetch data.');
        });
    },
    updatePie() {
      // 过滤出 value 不为 0 的数据
      const filteredData = this.chartData.filter(item => item.value !== 0);
      // 配置 echarts 饼图选项
      const option = {
        // title: { text: 'Chromosome Distribution'},
        tooltip: { trigger: 'item' },
        legend: {
            type: 'scroll', // 图例超出容器时启用滚动
            right: '2%', // 图例在容器右侧偏移 10%
            orient: 'horizontal', // 水平布局
            align: 'left', // 左对齐
            itemWidth: 20, // 控制每个图例项的宽度
            itemGap: 10, // 控制每个图例项之间的间距
        },
        series: [
          {
            name: 'Chromosome',
            type: 'pie',
            radius: [20, 150],
            center: ['50%', '50%'],
            roseType: 'radius',
            itemStyle: { borderRadius: 5, borderColor: '#fff', borderWidth: 2 },
            label: { show: true, fontSize: 14 },
            emphasis: { label: { show: true }, labelLine: { show: true } },
            data: filteredData,
          },
        ],
      };
      // 使用 echarts 饼图实例设置选项和数据
      this.chartPie.setOption(option);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/compartment/Abchr.vue